module.exports = {"640402001":"南关街道","640402002":"古雁街道","640402003":"北塬街道","640402100":"三营镇","640402103":"官厅镇","640402104":"开城镇","640402105":"张易镇","640402106":"彭堡镇","640402107":"头营镇","640402108":"黄铎堡镇","640402200":"中河乡","640402201":"河川乡","640402204":"炭山乡","640402205":"寨科乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640402.json
// module id = 3181
// module chunks = 0